/** @jsxImportSource @emotion/react */
import { FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, Typography,Chip } from '@mui/material';
import { Il8nContext } from '../../Helper/i18n';
import { useContext } from 'react';

function SubbrokerBrokerage(props) {
    const { brokeragePlans, handleBrokeragePlanSelection, selectedPlan, selectedDPCharge, handleDPPlanSelection, toggleDepositoryDetailsPopup /* plan, isSmallScreen, getDPChargeUI, paymentDone */ } = props
    const localeText = useContext(Il8nContext)
    
    return (
        <Grid container spacing={1} key={selectedDPCharge?.depositorySchemeId} css={{ borderRadius: "5px", boxShadow: "0px 3px 6px #00000029" }}>
            {brokeragePlans?.brokerageplan?.map(plan => (
                <Grid container item justifyContent={"space-evenly"} alignItems={"center"}
                    css={{ backgroundColor: (selectedPlan?.id == plan.id) ? "#F5FBFF" : "white", cursor: "pointer", border: "1px solid lightgrey" }}
                >
                    <Grid item xs={12} lg={2} sm={2} onClick={() => { handleBrokeragePlanSelection(plan) }}>
                        <RadioGroup css={{ fontWeight: "bold" }} key={selectedPlan?.id} value={selectedPlan?.id}>
                            <FormControlLabel value={plan.id} control={<Radio size='small' />} label={plan.name} />
                        </RadioGroup>
                    </Grid>
                    <Grid item lg={2}>
                        <Typography variant="body2" fontWeight={"bold"}>
                            {plan.mAmount} {plan.maxMarginAmount ? ("-" + plan.maxMarginAmount) : ""}
                        </Typography>
                        <Typography variant="body2" color="#FC9D00">
                            {localeText?.planDetailsMargin}(₹)
                        </Typography>
                    </Grid>
                    <Grid item lg={2} >
                        <Typography variant="body2" fontWeight={"bold"}>
                            {plan.delvMPaisa}
                        </Typography>
                        <Typography variant="body2" color="#1A95A8">
                            {localeText?.planDetailsIntraday}(₹)
                        </Typography>
                    </Grid>
                    <Grid item lg={2}>
                        <Typography variant="body2" fontWeight={"bold"}>
                            {plan.delvMxPerc}
                        </Typography>
                        <Typography variant="body2" color="#3BC0F5">
                            {localeText?.planDetailsDelivery}(₹)
                        </Typography>
                    </Grid>
                    <Grid item lg={2} xs={10} md={4} sm={3} css={{ padding: "10px" }}>
                        <Typography variant="body2">{localeText?.planDetailsDPServiceCharge}</Typography>
                        <Select
                            fullWidth
                            value={selectedDPCharge?.depositorySchemeId}
                            size="small"
                            onChange={(e) => {
                                let selection = brokeragePlans?.depositoryschememaster.find(opt => opt.depositorySchemeId == e.target.value)
                                if (selectedPlan) {
                                    handleDPPlanSelection(selection, e.target.value)
                                }
                            }}
                            disabled={!selectedPlan || selectedPlan?.id != plan.id}
                        >
                            <MenuItem value="">{localeText?.nomineeDetailsSelectValue}</MenuItem>
                            {selectedPlan?.id == plan.id &&  brokeragePlans?.depositoryschememaster?.map((opt, index) => <MenuItem value={opt.depositorySchemeId}>{opt.depositorySchemeName}</MenuItem>)}
                        </Select>
                    </Grid>
                    <Grid  item lg={1.25} xs={10} md={4} sm={3} css={{ padding: "10px" }}>
                    <Chip label={localeText?.schemeDetailsTitle} disabled={!selectedPlan || selectedPlan?.id != plan.id || !selectedDPCharge} variant="outlined" color="primary" css={{float:"right"}}  onClick={ selectedDPCharge? toggleDepositoryDetailsPopup :null }  />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
}

export default SubbrokerBrokerage;